import { debug } from './configuration'

let data = null

export class AutoMonetize {
  static loadPartnersFrom(element) {
    data = JSON.parse(element.textContent)
  }

  static clear() {
    data = null
  }

  static get data() {
    return data
  }

  constructor(url, { target, rel = 'sponsored' } = {}) {
    this.url = url
    this.partner = lookupPartner(url)
    this.target = target
    this.rel = rel
  }

  goToGeneratedUrl() {
    const link = document.createElement('a')
    link.href = this.monetizedUrl
    link.target = this.target
    link.rel = this.rel
    link.relList.add('sponsored')
    link.hidden = true

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    log('go to', link.href)
  }

  canMonetize() {
    return this.partner !== null
  }

  get monetizedUrl() {
    const template = this.resolveTemplate()
    const uri = new URL(this.trackingUrl(template) || this.currentUrlFor(template))

    if (template.search) {
      let search = template.search.replace(
        ':current_url',
        window.encodeURIComponent(this.currentUrlFor(template))
      )
      template.placeholders?.forEach((variable) => {
        search = search.replace(`:${variable}`, this.partner[variable])
      })
      uri.search = search
    }

    if (!template.fragment) return uri.toString()
    return uri.toString() + template.fragment
  }

  trackingUrl(template) {
    if (!template.tracking_url) return

    return template.tracking_url.replace(
      ':current_url',
      window.encodeURIComponent(this.currentUrlFor(template))
    )
  }

  // A landing_url sends the visitor through an intermediary deep link rather than
  // straight to the merchant, in which case the merchant url travels as a parameter
  // (spelled `:current_url`) and gets escaped one extra time along the way.
  currentUrlFor(template) {
    const uri = new URL(template.landing_url || this.url)
    if (template.current_url_search_params) {
      for (const key of Object.keys(template.current_url_search_params)) {
        const value = String(template.current_url_search_params[key])
        uri.searchParams.set(key, value.replace(':current_url', this.url))
      }
    }
    return uri.toString()
  }

  resolveTemplate() {
    if (this.partner.tracking_url) return this.partner
    if (this.provider) return this.provider

    return this.partner
  }

  get provider() {
    return data.providers[this.partner.provider]
  }
}

function lookupPartner(url) {
  for (const partner of data.partners) {
    const pattern = new RegExp(partner.pattern)
    if (url.match(pattern)) {
      log('found partner', partner)
      return partner
    }
  }

  return null
}

function log(...args) {
  if (debug) {
    console.debug('[automonetize]', ...args)
  } else if (document.location.search.includes('automonetizelog=true')) {
    console.log('[automonetize]', ...args)
  }
}
if (debug) window.AutoMonetize = AutoMonetize
